import "./advantages.css";
import { WrapperComponent, SectionTitle } from "../../../_imports";
import ContractsIcon from "../../../../assets/icons/samples/contracts.png";
import DivulgacaoIcon from "../../../../assets/icons/samples/divulgacao.png";
import IaIcon from "../../../../assets/icons/samples/ia.png";
import VelocityIcon from "../../../../assets/icons/samples/velocity.png";

function Advantages() {
    const advantages = [
        {
            id: 1,
            title: "Centralize suas divulgações",
            description: "Publique na plataforma e nós replicamos sua vaga em vários canais, centralizando todo o processo de divulgação.",
            icon: DivulgacaoIcon
        },
        {
            id: 2,
            title: "Adiante a primeira entrevista com IA",
            description: "A Tonia realiza a primeira entrevista e analisa a compatibilidade do candidato, agilizando a sua triagem inicial.",
            icon: IaIcon
        },
        {
            id: 3,
            title: "Contrate quantos precisar",
            description: "Cobramos por tempo de anúncio, nesse período, você pode contratar quantos candidatos precisar sem custos extras.",
            icon: ContractsIcon
        },
        {
            id: 4,
            title: "Selecione mais rápido",
            description: "Com os dados organizados visualmente, você tem agilidade total para aprovar ou rejeitar candidatos com um clique.",
            icon: VelocityIcon
        }
    ];

    return (
        <section className="advantages-section">
            <WrapperComponent>
                <SectionTitle text="VANTAGENS EXCLUSIVAS" />
                <div className="advantages-grid">
                    {advantages.map((adv) => (
                        <div key={adv.id} className="advantage-card">
                            <div className="advantage-icon">
                                <img src={adv.icon} alt={adv.title} />
                            </div>
                            <h3 className="advantage-card-title">{adv.title}</h3>
                            <p className="advantage-card-desc">{adv.description}</p>
                        </div>
                    ))}
                </div>
            </WrapperComponent>
        </section>
    );
}

export default Advantages;
